var _g, _g2, _g3, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsmNormal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_25782",
    "data-name": "Group 25782",
    transform: "translate(-793 -709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25781",
    "data-name": "Group 25781",
    transform: "translate(793 709)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Container_56x56_Copy_30",
    "data-name": "Icon Container 56x56 Copy 30"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25778",
    "data-name": "Group 25778"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25779",
    "data-name": "Group 25779"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14056",
    "data-name": "Path 14056",
    d: "M28,56A28,28,0,1,1,56,28,28.032,28.032,0,0,1,28,56ZM28,1A27,27,0,1,0,55,28,27.03,27.03,0,0,0,28,1Z",
    fill: "#e0e0e0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25771",
    "data-name": "Group 25771"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3856",
    "data-name": "Rectangle 3856",
    width: 36,
    height: 36,
    transform: "translate(10 10)",
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_25770",
    "data-name": "Group 25770"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14057",
    "data-name": "Path 14057",
    d: "M37,43H18.985A3,3,0,0,1,16,40V16a3,3,0,0,1,3-3H31l9,9V40A3,3,0,0,1,37,43ZM31,14.75h0V20.5A1.5,1.5,0,0,0,32.5,22h5.75Z",
    fill: "#217346"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "X",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25780",
    "data-name": "Group 25780",
    style: {
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14058",
    "data-name": "Path 14058",
    d: "M24.173,31.638l-2.7-5.058h2.769l.848,1.889c.241.48.465,1.024.753,1.68H25.9c.24-.656.464-1.2.656-1.68l.768-1.889h2.642l-2.69,5.17L30.144,37H27.375L26.4,34.951c-.256-.528-.5-1.072-.752-1.713h-.064c-.241.641-.48,1.185-.7,1.713L23.965,37H21.308Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14059",
    "data-name": "Path 14059",
    d: "M31.612,35.655a1.482,1.482,0,1,1,1.473,1.537A1.474,1.474,0,0,1,31.612,35.655Zm.321-7.171-.08-2.209h2.48l-.08,2.209L33.9,33.238H32.284Z",
    fill: "#fff"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsmNormal);
export default __webpack_public_path__ + "static/media/xlsm-normal.7048346c15868ec0870b3d4501def40a.svg";
export { ForwardRef as ReactComponent };